import { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '@codex/themes';
import { Icon } from '@codex/icons';

const HeaderRow = styled.tr`
  cursor: pointer;
  color: ${colors.link.default};
  border-top: 2px solid ${colors.link.default};
`;

const HeaderCell = styled.th`
  border: 1px solid ${colors.shades[5]};
  padding: 5px 7px;
  vertical-align: top;
  text-align: left;
`;

const ChevronIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`;

const SpecificationNameCell = styled.th`
  border: 1px solid ${colors.shades[5]};
  padding: 5px 7px;
  vertical-align: top;
  text-align: left;
  background: ${colors.shades[6]};
  width: 20%;
`;

const SpecificationValueCell = styled.td`
  border: 1px solid ${colors.shades[5]};
  padding: 5px 7px;
  vertical-align: top;
  text-align: left;
  width: 20%;
  overflow: hidden;
  
  &.highlighted {
    background-color: #e6f4ff;
  }
`;

export default function TechnicalSpecificationSection({ sectionData, highlightRowsWithDifferentValues }) {
  const [hideSectionRow, setHideSectionRow] = useState(false);

  return (
    <tbody key={sectionData.sectionLabel}>
      <HeaderRow onClick={() => { setHideSectionRow(!hideSectionRow); }}>
        <HeaderCell colSpan={'5'}>
          <ChevronIcon
            icon={'ArrowDown'}
            rotate={hideSectionRow ? 180 : 0}
          />
          {sectionData.sectionLabel.toUpperCase()}
        </HeaderCell>
      </HeaderRow>
      {!hideSectionRow
        ? (
          sectionData.rows.map((rowData) => (
            <tr key={rowData.firstColumnLabel}>
              <SpecificationNameCell>
                {rowData.firstColumnLabel}
              </SpecificationNameCell>
              {
                rowData.otherColumnsLabels.map((cellValueLabel, i) => (
                  <SpecificationValueCell
                    key={String(i) + cellValueLabel}
                    className={
                      highlightRowsWithDifferentValues &&
                      !rowData.otherColumnsLabels.every(
                        (label) => label === rowData.otherColumnsLabels[0]) ? 'highlighted' : ''
                    }
                  >
                    {cellValueLabel.split('- ')
                      .map((line, j) => (
                        j > 0
                          ? (
                            <Fragment key={String(j) + line}>
                              <span>
                                {`- ${line}`}
                              </span>
                              <br />
                            </Fragment>
                          )
                          : line
                      ))}
                  </SpecificationValueCell>
                ))
              }
            </tr>
          ))
        )
        : null}
    </tbody>
  );
}

TechnicalSpecificationSection.propTypes = {
  sectionData: PropTypes.shape({
    sectionLabel: PropTypes.string.isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({
      firstColumnLabel: PropTypes.string.isRequired,
      otherColumnsLabels: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
    }).isRequired
    ).isRequired
  }).isRequired,
  highlightRowsWithDifferentValues: PropTypes.bool
};

TechnicalSpecificationSection.defaultProps = {
  highlightRowsWithDifferentValues: false
};
